import { WidgetType } from './widgetType';
export var TextType;
(function (TextType) {
    TextType["text"] = "text";
    TextType["note"] = "imageFull";
})(TextType || (TextType = {}));
export var NoteColorTheme;
(function (NoteColorTheme) {
    NoteColorTheme["default"] = "default";
    NoteColorTheme["sky"] = "sky";
    NoteColorTheme["blueberry"] = "blueberry";
    NoteColorTheme["jelly"] = "jelly";
    NoteColorTheme["cherry"] = "cherry";
    NoteColorTheme["tangerine"] = "tangerine";
    NoteColorTheme["basil"] = "basil";
})(NoteColorTheme || (NoteColorTheme = {}));
export const TextWidgetHelper = {
    isTextWidget: (widget) => {
        return widget.value.type === WidgetType.text;
    },
};
